import {useEffect, useState} from "react";

const PhoneNumberFieldSimple = (props) => {
    const [phoneNumber, setPhoneNumber] = useState('');


    useEffect(() => {
        if (props.value){
            setPhoneNumber(props.value);
        }
    }, [props.value]);
    
    const handeValueChange = (event) => {
        const value = event.target.value;
        setPhoneNumber(value);
        props.OnChangeValue(value);
    }
    
    return (
        <div>
            <div>
                <label className={'p-1'}>
                    {props.label}
                </label>
            </div>
            <div className={'p-1 rounded-md'}>
                <input
                    onChange={handeValueChange}
                    type='text'
                    value={phoneNumber}
                    pattern="[0-9]*"
                    placeholder="Enter phone number"
                />
            </div>
        </div>
    )

}

export default PhoneNumberFieldSimple;